module.exports = __webpack_public_path__ + "img/husd.c6651a58.svg";